import { useTranslation } from 'react-i18next';

import {
  ZfDialog,
  ZfDialogContent,
  ZfDialogFooter,
  ZfDialogHeader,
  ZfStack,
  ZfTextButton,
  ZfTypography,
} from '@zafire/react';

type AuditHistoryCustomCellDialogType = {
  showDialog: boolean;
  data: { header: string; title: string; data: string };
  onDialogClose: () => void;
};
const AuditHistoryCustomCellDialog = ({ showDialog, data, onDialogClose }: AuditHistoryCustomCellDialogType) => {
  const { t } = useTranslation();
  return (
    <ZfDialog show={showDialog} size="small" onDialogClose={onDialogClose} disableClose>
      <ZfDialogHeader>{data.header}</ZfDialogHeader>
      <ZfDialogContent>
        <ZfStack spacing="extra-extra-small">
          <ZfTypography variant="body-small" color="normal">
            {data.title}
          </ZfTypography>
          <ZfTypography variant="body-small">{data.data}</ZfTypography>
        </ZfStack>
      </ZfDialogContent>
      <ZfDialogFooter>
        <ZfStack slot="primary" direction="row" spacing="small">
          <ZfTextButton hierarchy="tertiary" size="medium" onClick={() => onDialogClose()}>
            {t('contactNote.form.errorDialog.close')}
          </ZfTextButton>
        </ZfStack>
      </ZfDialogFooter>
    </ZfDialog>
  );
};

export default AuditHistoryCustomCellDialog;
